import { useEffect, ReactNode } from "react";
import i18n from "i18next";

type Lang = "en" | "es";

interface LangWrapperProps {
  lang: Lang;
  children: ReactNode;
}

/**
 * Sets i18n language when visiting /en, /eng, /es, or /spanish so the URL reflects the language.
 */
export function LangWrapper({ lang, children }: LangWrapperProps) {
  useEffect(() => {
    i18n.changeLanguage(lang);
  }, [lang]);

  return <>{children}</>;
}

export function pathToLang(pathname: string): Lang | null {
  if (pathname === "/en" || pathname === "/eng") return "en";
  if (pathname === "/es" || pathname === "/spanish") return "es";
  return null;
}

export function langToPath(lang: string): string {
  return lang === "es" ? "/es" : "/en";
}
